export default class Arrays {

  static contains(array, element) {
    if (!array || !element) {
      return false;
    }
    return array.indexOf(element) >= 0;
  }

  static addElement(array, element) {
    return [...array, element]
  }

  static removeElementById(array, element) {
    let newArray = [...array];
    return newArray.filter(ele => ele.id !== element.id);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/utils/Arrays.js